import React, {Component} from 'react';
import Loading from '../../../components/Loading';
import Form from './Form';
import {connect} from 'react-redux';
import {ToastContainer, toast} from 'react-toastify';
import {SubmissionError} from 'redux-form';
import moment from 'moment';
import * as postService from '../../../services/post';

class Page extends Component {

  constructor(props) {

    super(props);

    this.state = {
      data: {},
      loaded: false,
      postTypeLst: [],
      postListTemplateLst: []
    }

    this.load = this.load.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentWillMount() {
    this.load();
  }

  load() {

    postService.getParams().then((data) => {

      this.setState({
        postTypeLst: data.postTypeLst,
        postListTemplateLst: data.postListTemplateLst,
      });

    });

    if (this.props.match.params.id) {

      postService.view(this.props.match.params.id).then((data) => {

        if (data.publicationDate) {
          data.publicationDate = moment(data.publicationDate).format('YYYY-MM-DD');
        }

        if (data.topHomeDate) {
          data.topHomeDate = moment(data.topHomeDate).format('YYYY-MM-DD');
        }

        this.setState({
          data,
          loaded: true
        });

      });

    } else {

      this.setState({loaded: true});

    }

  }


  submit(values){
    this.setState({ loaded: false });


    const edit = (!values.id) ? postService.create : postService.update;

    if (values.buyer == null) {
      values.buyer = false;
    }
    if (values.seller == null) {
      values.seller = false;
    }

    if (values.webSite == null) {
      values.webSite = false;
    }

    if (!values.published) {
      values.published = false;
    }

    if (!values.topHomeDate) {
      values.topHomeDate = null;
    }


    values.postType = values.postType * 1;

    return edit(values).then((data) => {
      this.setState({data});
      this.setState({loaded: true});

      toast.success('Enregistrement réussi');

    }).catch((error) => {

      this.setState({ loaded: true });

      throw new SubmissionError(error);

    });

  }

  render() {

    const {history, match} = this.props;
    const {data, loaded, postTypeLst, postListTemplateLst} = this.state;

    return (
        <div className="animated fadeIn">

          {!loaded && <Loading />}
          {loaded && <Form onSubmit={this.submit} initialValues={data} postTypeLst={postTypeLst} postListTemplateLst={postListTemplateLst}/>}


        </div>
    )
  }
}

export default Page





// WEBPACK FOOTER //
// ./src/views/Cms/Posts/Post.js